var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title" }, [
        _vm._v("Update Service Package"),
      ]),
      _c(
        "div",
        { staticClass: "modal-header--actions" },
        [
          _c(
            "md-button",
            {
              staticClass:
                "md-simple md-just-icon md-round modal-default-button",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$modal.hide($event)
                },
              },
            },
            [_c("md-icon", [_vm._v("clear")])],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c("div", [
          _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n                Original Service Package:\n                "
            ),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.originalRateGroup != null ? _vm.originalRateGroup : "None"
                )
              ),
            ]),
          ]),
        ]),
        _c("charging-type-options", {
          ref: "chargingType",
          staticClass: "charging-type-options",
          attrs: {
            "selected-charge-type-id": _vm.selectedRateGroupId,
            "label-name": "",
            "service-packages": _vm.servicePackages,
          },
          on: { selectedOption: _vm.servicePackageChanged },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.updateServicePackage($event)
              },
            },
          },
          [_vm._v("\n            Update\n        ")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }